import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const RecognizedProfessionNameFilter = ({
  label = "l.searchFilter.recognizedProfessionName",
  ...others
}: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"recognizedProfessionName"} label={label} {...others} />
    </>
  );
};

export default RecognizedProfessionNameFilter;
